<template>
    <transition name="cg-fade">
        <div v-if="visible" class="cg-container" :class="[critType, { 'impact-shake': isImpact }]">
            <!-- 1. 动态暗色背景与背景光芒 -->
            <div class="cg-bg">
                <div class="light-shockwave" :class="{ active: isImpact }"></div>
            </div>

            <!-- 2. 流星轨迹 (从右上角到屏幕中心) -->
            <div v-if="showMeteor" class="meteor-container">
                <div class="meteor">
                    <!-- 流星拖尾 -->
                    <div class="meteor-tail"></div>
                    <!-- 流星头部高亮焦点 -->
                    <div class="meteor-head"></div>
                </div>
            </div>

            <!-- 3. 中心爆炸/闪光粒子效果 -->
            <div class="impact-flash" :class="{ active: isImpact }"></div>

            <!-- 4. 核心奖励与文字展现 (冲击后触发) -->
            <div v-if="showContent" class="reward-content">
                <!-- 暴击/大吉 动态特效大字 -->
                <div v-if="critType" class="cg-title" :class="critType">
                    <img v-if="critType === 'S'" class="fade-up-in" src="@/assets/imgs/AutumnFestival/S.png" alt="S" />
                    <img v-else-if="critType === 'A'" class="fade-up-in" src="@/assets/imgs/AutumnFestival/A.png" alt="A" />
                    <img v-else-if="critType === 'B'" class="fade-up-in" src="@/assets/imgs/AutumnFestival/B.png" alt="B" />
                </div>

                <!-- 3D/道具展示卡片 -->
                <div class="reward-card">
                    <div class="card-glow"></div>
                    <div class="img-wrapper">
                        <!-- 替换为你模型的 2D 预览图或图标 -->
                        <img v-if="critType === 'S'" src="@/assets/imgs/AutumnFestival/S_icon.png" alt="道具" class="prop-img" />
                        <img v-else-if="critType === 'A'" src="@/assets/imgs/AutumnFestival/A_icon.png" alt="道具" class="prop-img" />
                        <img v-else-if="critType === 'B'" src="@/assets/imgs/AutumnFestival/B_icon.png" alt="道具" class="prop-img" />
                    </div>
                    <!-- <div class="prop-name">{{ rewardData.name }}</div> -->
                    <div class="prop-name">恭喜获得</div>
                    <div class="prop-count">× {{ rewardData.count }}</div>
                </div>

                <!-- CG 级收下按钮 -->
                <button class="cg-btn" @click="close">
                    <span>开心收下</span>
                </button>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'CgRewardModal',
    data() {
        return {
            visible: false,
            showMeteor: false,
            isImpact: false,
            showContent: false,
            rewardData: { name: '清凉碎片', count: 6, icon: '' }
        }
    },
    computed: {
        critType() {
            if (this.rewardData.name === '幸运月饼') {
                if (this.rewardData.count === 'S') return 'S' // S
                if (this.rewardData.count === 'A') return 'A' // A
                if (this.rewardData.count === 'B') return 'B' // B
            }
            return ''
        },
        critText() {
            if (this.critType === 'S') return 'CRITICAL! S'
            if (this.critType === 'A') return 'LUCKY! A'
            if (this.critType === 'B') return 'LUCKY! B'
            return '获得奖励'
        }
    },
    methods: {
        show(data) {
            this.rewardData = data
            this.visible = true
            this.showMeteor = true
            this.isImpact = false
            this.showContent = false

            // 动画时间轴控制 (Timeline)
            // 1. 流星下坠耗时 0.6s
            setTimeout(() => {
                this.showMeteor = false
                this.isImpact = true // 触发撞击闪光与震屏
            }, 600)

            // 2. 撞击 0.15s 后展示文字与物品
            setTimeout(() => {
                this.showContent = true
            }, 750)
        },
        close() {
            this.visible = false
            this.$emit('LotteryModalOK')
        }
    }
}
</script>

<style scoped lang="less">
// ==================== 1. Less 变量定义 ====================
@gold-main: #ffd700;
@gold-dark: #b8860b;
@crit-red: #ff3300;
@super-pink: #ff1493;
@ease-impact: cubic-bezier(0.175, 0.885, 0.32, 1.275);
@ease-meteor: cubic-bezier(0.25, 0.1, 0.25, 1);

// ==================== 2. 主体 Less 嵌套样式 ====================
.cg-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 99999;
    background: #000;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    /* 屏幕震动效果 (撞击瞬间) */
    &.impact-shake {
        animation: cameraShake 0.4s ease-in-out;
    }

    /* 动态暗色背景 */
    .cg-bg {
        position: absolute;
        width: 100%;
        height: 100%;
        background: radial-gradient(circle at center, #111b29 0%, #05070a 100%);
        z-index: 1;

        .light-shockwave {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            transform: translate(-50%, -50%);
            background: radial-gradient(circle, rgba(255, 255, 255, 0.8) 0%, rgba(255, 215, 0, 0) 70%);
            opacity: 0;
            z-index: 2;

            &.active {
                animation: shockwaveExpand 0.8s ease-out forwards;
            }
        }
    }

    /* --- 🌠 流星与拖尾效果 --- */
    .meteor-container {
        position: absolute;
        top: -100px;
        right: -100px;
        width: 100vw;
        height: 100vh;
        z-index: 10;
        pointer-events: none;

        .meteor {
            position: absolute;
            width: 4px;
            height: 4px;
            animation: meteorFly 0.6s @ease-meteor forwards;

            .meteor-head {
                width: 12px;
                height: 12px;
                background: #fff;
                border-radius: 50%;
                box-shadow: 0 0 20px 10px #fff, 0 0 40px 20px #ffaa00;
            }

            .meteor-tail {
                position: absolute;
                top: 50%;
                left: 0;
                width: 350px;
                height: 4px;
                background: linear-gradient(90deg, #ffffff, rgba(255, 180, 50, 0.8), transparent);
                transform: translateY(-50%) rotate(-45deg);
                transform-origin: left center;
                box-shadow: 0 0 15px #ffaa00, 0 0 30px #ff5500;
            }
        }
    }

    /* --- 暴击 / 大吉 配色覆盖 --- */
    &.crit {
        .meteor-tail {
            background: linear-gradient(90deg, #fff, @crit-red, transparent) !important;
            box-shadow: 0 0 20px @crit-red, 0 0 40px #ff1100 !important;
        }

        .cg-title {

            .text-main {
                background: linear-gradient(180deg, #ffffff 0%, @crit-red 60%, #8b0000 100%);
                -webkit-background-clip: text;
            }

            .text-glow {
                color: @crit-red;
            }
        }
    }

    &.super {
        .meteor-tail {
            background: linear-gradient(90deg, #fff, @gold-main, @super-pink, transparent) !important;
            box-shadow: 0 0 20px @gold-main, 0 0 40px @super-pink !important;
        }
    }

    /* --- 💥 爆炸闪光 --- */
    .impact-flash {
        position: absolute;
        width: 100vw;
        height: 100vh;
        background: #fff;
        opacity: 0;
        z-index: 20;
        pointer-events: none;

        &.active {
            animation: flashTrigger 0.3s ease-out;
        }
    }

    /* --- 🏆 内容展示层 --- */
    .reward-content {
        position: relative;
        z-index: 30;
        display: flex;
        flex-direction: column;
        align-items: center;
        animation: contentImpact 0.5s @ease-impact forwards;

        /* 大字特效 */
        .cg-title {
            position: absolute;
            top: -45%;
            left: -68%;
            font-size: 72px;
            font-weight: 900;
            font-style: italic;
            letter-spacing: 8px;
            text-transform: uppercase;
            margin-bottom: 20px;
            transform: rotate(335deg);
            z-index: 10;

            >img {
                max-width: 255px;
            }

            .text-main {
                position: relative;
                background: linear-gradient(180deg, #ffffff 0%, @gold-main 60%, @gold-dark 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.8));
            }

            .text-glow {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                color: @gold-main;
                filter: blur(15px);
                opacity: 0.8;
            }

            /* 动画定义 */
            @keyframes fadeUpIn {
                0% {
                    opacity: 0;
                    transform: translateY(50px);
                }

                100% {
                    opacity: 1;
                    transform: translateY(0);
                }
            }

            /* 使用class */
            .fade-up-in {
                animation: fadeUpIn 3s ease-out forwards;
            }
        }

        /* 道具展示卡片 */
        .reward-card {
            position: relative;
            width: 260px;
            height: 300px;
            background: rgba(255, 255, 255, 0.05);
            border: 1px solid rgba(255, 215, 0, 0.3);
            box-shadow: 0 0 30px rgba(0, 0, 0, 0.8), inset 0 0 15px rgba(255, 215, 0, 0.2);
            border-radius: 16px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            backdrop-filter: blur(10px);

            .img-wrapper {
                width: 140px;
                height: 140px;
                display: flex;
                align-items: center;
                justify-content: center;

                .prop-img {
                    max-width: 100%;
                    max-height: 100%;
                    filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.6));
                    animation: floatProp 3s ease-in-out infinite;
                }
            }

            .prop-name {
                color: #e0e0e0;
                font-size: 20px;
                font-weight: 600;
                margin-top: 15px;
            }

            .prop-count {
                color: @gold-main;
                font-size: 28px;
                font-weight: 900;
                margin-top: 5px;
                text-shadow: 0 0 10px rgba(255, 215, 0, 0.5);
            }
        }

        /* CG 科技风按钮 */
        .cg-btn {
            margin-top: 35px;
            width: 200px;
            height: 50px;
            background: linear-gradient(90deg, #d4af37, @gold-main, #d4af37);
            background-size: 200% 100%;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            box-shadow: 0 0 20px rgba(212, 175, 55, 0.4);
            transition: all 0.3s;
            clip-path: polygon(10% 0, 100% 0, 90% 100%, 0 100%);

            span {
                font-size: 20px;
                font-weight: 800;
                color: #000;
                letter-spacing: 2px;
            }

            &:hover {
                background-position: 100% 0;
                box-shadow: 0 0 30px rgba(255, 215, 0, 0.8);
                transform: scale(1.05);
            }
        }
    }
}

// ==================== 3. 帧动画 Keyframes ====================
@keyframes meteorFly {
    0% {
        top: -10vh;
        left: 110vw;
        opacity: 1;
    }

    100% {
        top: 50vh;
        left: 50vw;
        opacity: 1;
    }
}

@keyframes flashTrigger {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

@keyframes shockwaveExpand {
    0% {
        width: 10px;
        height: 10px;
        opacity: 1;
    }

    100% {
        width: 800px;
        height: 800px;
        opacity: 0;
    }
}

@keyframes cameraShake {

    0%,
    100% {
        transform: translate(0, 0);
    }

    20% {
        transform: translate(-10px, 8px);
    }

    40% {
        transform: translate(10px, -8px);
    }

    60% {
        transform: translate(-6px, 4px);
    }

    80% {
        transform: translate(6px, -4px);
    }
}

@keyframes contentImpact {
    0% {
        transform: scale(3);
        opacity: 0;
        filter: blur(10px);
    }

    100% {
        transform: scale(1);
        opacity: 1;
        filter: blur(0);
    }
}

@keyframes floatProp {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-12px);
    }
}

/* 渐隐过渡 */
.cg-fade-enter-active,
.cg-fade-leave-active {
    transition: opacity 0.4s;
}

.cg-fade-enter,
.cg-fade-leave-to {
    opacity: 0;
}
</style>